<template>
  <div>
    <div class="riTop">
      <span @click="openDatePicker">日</span>
      <el-date-picker
        ref="datePicker"
        v-model="pickedDate"
        type="date"
        placeholder=""
        value-format="yyyy-MM-dd"
        style="width: 5px; visibility: hidden"
        @change="setTime"
      />
    </div>
  </div>
</template>
<script>
import { printDate } from "@/utils";

export default {
  data() {
    return {
      pickedDate: printDate()
    };
  },
  methods: {
    openDatePicker() {
      this.$refs.datePicker.showPicker();
    },
    setTime(){
      this.$store.commit('dataTime/SET_Time', this.pickedDate)
    }
  }
};

</script>


<style scoped lang="scss">
.riTop {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
  cursor: pointer;

  span {
    font-size: 12px;
    color: #DBBD80;
    padding: 0px 6px;
    border: 1px solid #DBBD80;
    border-radius: 5px;
    border-top-width: 8px;
  }

  img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}

.card {
  flex: 2;
  background: #FFFFFF;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 20px;

  span:first-child {
    font-size: 22px;
    display: block;
    text-align: start;
    border-left: 5px solid #DBBD80;
    padding: 0px 10px;
    color: #DBBD80;
  }

  .cardTop {
    display: flex;
    align-items: stretch;
    margin-top: 10px;
    gap: 20px;
    margin-top: 20px;

    div {
      flex: 1;
      letter-spacing: 2px;
      img{
        width: 100px;
        height: 100px;
        object-fit: contain;
      }
       border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;
      i{
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }
      h2{
        color: #DBBD80;
        font-size: 60px;
        margin: 10px;

      }
      p{
        font-size: 20px;
        margin-bottom: 0;
      }
      span{
        color: #b6b8bd;
      }

    }
  }

  .cardToptwo{
     margin-top: 20px;
    display: flex;
    gap: 20px;
    .top{
      flex: 1;
      letter-spacing: 2px;
      border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;
      p{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        img{
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-right: 30px;
        }
      }
      i{
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }
      .bott{
          display: flex;
        justify-content: center;
        div{
          flex: 1;
          h2{
            font-size: 60px;
            color: #DBBD80;
            margin: 10px;
          }
          span{
            color: #b6b8bd;
          }
        }
      }
    }
  }
}
.cardtwo{
  flex: 1;
  .cardbody{
    background: #FFFFFF;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 45px 20px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;
    div:first-child{
      padding-right: 20px;
      margin-right: 50px;
    }
    img{
      width: 100px;
      height: 100px;
      object-fit: contain;
      margin-right: 50px;
    }
    p{
      font-size: 20px;
      margin: 0;
      padding-right: 20px;
      border-right: 3px solid #DBBD80;
    }
    h2{
      font-size: 60px;
      color: #DBBD80;
      margin: 10px;
    }
    span{
      color: #b6b8bd;
    }
  }
}
</style>
